import React from 'react';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import LegalNotice from './Legal/LegalNotice';

import styles from '../styles/MiniTables.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as XIcon } from '../icons/x-close.svg';
import { ReactComponent as TrashIcon } from '../icons/trash.svg';

const FileUploadField = ({
    label,
    buttonLabel,
    file,
    onChange,
    onReset,
    allowMultiple = false,
    allowedFileTypes = ['pdf'],
    isAlreadyOpened = false,
    isCloseButton = true,
}) => {
    const inputRef = React.useRef(null);
    const { openTimeModal } = useTimeModal();
    const [isPanelOpen, setIsPanelOpen] = React.useState(false);

    const renderFileList = () => {
        if (!file) return null;

        const fileArray = allowMultiple ? file : [file];

        return (
            <div className={styles.table}>
                {fileArray.map((f, index) => (
                    <div 
                        key={index} 
                        className={styles.line}
                        style={{ gridTemplateColumns: '99fr 1fr' }}
                    >
                        {f.name}
                        <IconContainer
                            Icon={XIcon}
                            onClick={() => onReset(index)}
                            size='17'
                            color='red'
                            className=''
                        />
                    </div>
                ))}
            </div>
        );
    };

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files || []);

        // фильтруем по расширению
        const filteredFiles = newFiles.filter(f => {
            const ext = f.name.split('.').pop().toLowerCase();
            return allowedFileTypes.includes(ext);
        });

        if (filteredFiles.length !== newFiles.length) {
            openTimeModal(`Некоторые файлы не были добавлены. Разрешены только: ${allowedFileTypes.join(', ')}`, 'warning');
        }

        if (allowMultiple) {
            const updatedFiles = [...(file || []), ...filteredFiles];
            onChange({ target: { files: updatedFiles } });
        } else {
            onChange({ target: { files: filteredFiles } });
        }

        e.target.value = '';
    };

    return (
        <>
            {(isPanelOpen || isAlreadyOpened) ? (
                    <div className='panel'>
                        <div className='panelHeader'>
                            <h3>{label}</h3>
                            {isCloseButton && <IconContainer Icon={XIcon} onClick={() => setIsPanelOpen(false)} size='17' color='black' className='' />}
                        </div>
                        <div className='panelMain'>
                            <label
                                className='customFileUpload'
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.classList.add('dragOver');
                                }}
                                onDragLeave={(e) => {
                                    e.currentTarget.classList.remove('dragOver');
                                }}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    e.currentTarget.classList.remove('dragOver');

                                    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                                        const newFiles = Array.from(e.dataTransfer.files || []);

                                        const filteredFiles = newFiles.filter(f => {
                                            const ext = f.name.split('.').pop().toLowerCase();
                                            return allowedFileTypes.includes(ext);
                                        });

                                        if (filteredFiles.length !== newFiles.length) {
                                            openTimeModal(
                                                `Некоторые файлы не были добавлены. Разрешены только: ${allowedFileTypes.join(', ')}`,
                                                'warning'
                                            );
                                        }

                                        if (allowMultiple) {
                                            const updatedFiles = [...(file || []), ...filteredFiles];
                                            onChange({ target: { files: updatedFiles } });
                                        } else {
                                            onChange({ target: { files: filteredFiles } });
                                        }
                                    }
                                }}
                                >
                                <input
                                    type='file'
                                    accept={allowedFileTypes.map(type => type.startsWith('.') ? type : `.${type}`).join(',')}
                                    ref={inputRef}
                                    onChange={handleFileChange}
                                    multiple={allowMultiple}
                                    style={{ display: 'none' }}
                                />
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="cloud-upload"><path fill="currentColor" d="M18.42,8.22A7,7,0,0,0,5.06,10.11,4,4,0,0,0,6,18a1,1,0,0,0,0-2,2,2,0,0,1,0-4,1,1,0,0,0,1-1,5,5,0,0,1,9.73-1.61,1,1,0,0,0,.78.67,3,3,0,0,1,.24,5.84,1,1,0,0,0,.5,1.94,5,5,0,0,0,.17-9.62Zm-5.71,2.07a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L11,13.41V19a1,1,0,0,0,2,0V13.41l1.29,1.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"></path></svg>
                                <h2>Перетащите файл сюда или нажмите, чтобы выбрать{allowMultiple ? ' файлы' : ''}</h2>
                                <p className='description'>{allowedFileTypes.map(type => type.startsWith('.') ? type : `.${type}`).join(', ')} — До 200 мб</p>
                            </label>
                            {file && (allowMultiple ? file.length > 0 : true) ? (
                                <div className="fileListWrapper">
                                {renderFileList()}
                                </div>
                            )
                            :
                            (
                                // <LegalNotice />
                                <></>
                            )}
                        </div>
                    </div>
            ) : (
                <button className='button miniButton' onClick={() => setIsPanelOpen(true)}>
                    {buttonLabel || 'Прикрепить скан документа'}
                </button>
            )}
        </>
    );
};

export default FileUploadField;
